import { Box, Typography } from "@mui/material";
import React from "react";
import img1 from "../../images/testimonial.png";

export default function TestimonialCard() {
  return (
    <>
      <Box
        sx={{
          width: "100%",
          height: "100%",
          bgcolor: "#F5F6F7",
          borderRadius: "20px",
        }}
      >
        <Box p={5}>
          <Box>
            <Box spacing="4">
              <Box sx={{ display: "flex", gap: 2, alignItems: "center" }}>
                <img src={img1} alt="img" style={{ width: "4rem" }} />
                <Box>
                  <Typography
                    sx={{
                      fontFamily: "Inter",
                      fontWeight: 400,
                      fontSize: "14px",
                      lineHeight: "22px",
                      color:' #061C3D'
                    }}
                  >
                    Annette Black
                  </Typography>
                  <Typography   sx={{
                      fontFamily: "Inter",
                      fontWeight: 300,
                      fontSize: "12px",
                      lineHeight: "18px",
                      color:' #42526B'
                    }}>CEO of Acdomy</Typography>
                </Box>
              </Box>
            </Box>
          </Box>
          <Box>
            <Typography  sx={{
                      fontFamily: "Inter",
                      fontWeight: 300,
                      fontSize: "14px",
                      lineHeight: "22px",
                      color:' #061C3D',
                      mt:3
                    }}>
              “Working with Golio was a great experience, understanding person,
              fast response time dose his work with honestly, experienced, a
              problem solver. Gives it it's all. I highly recommend him for
              providing beyond of high quality service.”
            </Typography>
          </Box>
        </Box>
      </Box>
    </>
  );
}
